import numeral from 'numeral'

export const numeralSetupIt = () => {
  // load a language
  numeral.language('it', {
    delimiters: {
      thousands: '.',
      decimal: ',',
    },
    abbreviations: {
      thousand: 'k',
      million: 'm',
      billion: 'b',
      trillion: 't',
    },

    currency: {
      symbol: '€',
    },
  })
}
